export default __webpack_public_path__ + "static/media/whatsapp-icon.ab0d2402.svg";